import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Mail, ChevronRight, Copy, Download } from 'lucide-react';
import api from '../services/api';
import toast from 'react-hot-toast';

export default function Campaigns() {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/api/campaigns').then(r => setCampaigns(r.data.campaigns || [])).finally(() => setLoading(false));
  }, []);

  const duplicate = async (e, id) => {
    e.stopPropagation();
    try {
      const res = await api.post(`/api/campaigns/${id}/duplicate`);
      toast.success('Campaign duplicated!');
      navigate(`/campaigns/${res.data.campaign.id}`);
    } catch { toast.error('Failed to duplicate'); }
  };

  const exportCSV = (e, id) => {
    e.stopPropagation();
    const token = localStorage.getItem('bulkify_token');
    const url = `${process.env.REACT_APP_API_URL || 'http://localhost:4000'}/api/campaigns/${id}/export`;
    const a = document.createElement('a');
    a.href = url;
    a.setAttribute('download', '');
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.blob()).then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        a.href = blobUrl;
        a.click();
        URL.revokeObjectURL(blobUrl);
      });
  };

  const statusBadge = (s) => {
    const map = { running: 'badge-blue', paused: 'badge-amber', completed: 'badge-green', draft: 'badge-gray', stopped: 'badge-red' };
    return <span className={`badge ${map[s] || 'badge-gray'}`}>{s}</span>;
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 28 }}>
        <div>
          <h1 style={{ fontSize: 20, fontWeight: 600, letterSpacing: '-0.4px' }}>Campaigns</h1>
          <p style={{ color: 'var(--text2)', fontSize: 13, marginTop: 3 }}>All your email sequences in one place</p>
        </div>
        <button className="btn btn-primary" onClick={() => navigate('/campaigns/new')}>
          <Plus size={14} /> New campaign
        </button>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center', color: 'var(--text3)', fontSize: 13 }}>Loading…</div>
        ) : campaigns.length === 0 ? (
          <div style={{ padding: 60, textAlign: 'center' }}>
            <Mail size={36} color="var(--text3)" style={{ marginBottom: 14 }} />
            <p style={{ color: 'var(--text2)', fontSize: 14, fontWeight: 500, marginBottom: 6 }}>No campaigns yet</p>
            <p style={{ color: 'var(--text3)', fontSize: 12, marginBottom: 18 }}>Create your first campaign to start sending</p>
            <button className="btn btn-primary" onClick={() => navigate('/campaigns/new')}><Plus size={14} /> New campaign</button>
          </div>
        ) : (
          <>
            <div style={{ padding: '0', borderBottom: '1px solid var(--border)' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    {['Campaign', 'Status', 'Sent', 'Open rate', 'Replies', 'Created', ''].map(h => (
                      <th key={h} style={{ padding: '10px 20px', textAlign: 'left', fontSize: 11, color: 'var(--text3)', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em', borderBottom: '1px solid var(--border)' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {campaigns.map(c => (
                    <tr key={c.id} style={{ borderBottom: '1px solid var(--border)', cursor: 'pointer' }} onClick={() => navigate(`/campaigns/${c.id}`)}>
                      <td style={{ padding: '13px 20px' }}>
                        <div style={{ fontWeight: 500, fontSize: 13 }}>{c.name}</div>
                        <div style={{ fontSize: 11, color: 'var(--text3)' }}>{c.list_name}</div>
                      </td>
                      <td style={{ padding: '13px 20px' }}>{statusBadge(c.status)}</td>
                      <td style={{ padding: '13px 20px', fontSize: 13 }}>{(parseInt(c.emails_sent) || 0).toLocaleString()}</td>
                      <td style={{ padding: '13px 20px', fontSize: 13, color: 'var(--green)' }}>
                        {c.emails_sent > 0 ? `${((c.emails_opened / c.emails_sent) * 100).toFixed(0)}%` : '—'}
                      </td>
                      <td style={{ padding: '13px 20px', fontSize: 13 }}>{parseInt(c.replied_count) || 0}</td>
                      <td style={{ padding: '13px 20px', fontSize: 12, color: 'var(--text3)' }}>{new Date(c.created_at).toLocaleDateString()}</td>
                      <td style={{ padding: '13px 20px' }}>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn btn-ghost btn-sm" onClick={e => duplicate(e, c.id)} title="Duplicate"><Copy size={12} /></button>
                      <button className="btn btn-ghost btn-sm" onClick={e => exportCSV(e, c.id)} title="Export CSV"><Download size={12} /></button>
                      <ChevronRight size={14} color="var(--text3)" />
                    </div>
                  </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
